import { useFormSchema } from "src/api/hooks/useFormSchema";
import { ConditionalWidgetProps } from "./ConditionalWidgetProps";

export const StringWidget = (props: ConditionalWidgetProps) => {
  const { value, onChange, required, id, uiSchema, label } = props;
  const { data: schema } = useFormSchema();
  const primaryColor = schema?.theme?.colors?.primary;
  const secondaryColor = schema?.theme?.colors?.secondary;

  // Register cssOverride if it exists
  if (props.display) {
    return (
      <div className={`string-container container`}>
        <p className="text-sm text-Grey7">{value}</p>
      </div>
    );
  }
  return (
    <div className={`string-container container`}>
      <input
        id={`${id}-input`}
        name={label}
        type="text"
        className={`input-string`}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
      />
    </div>
  );
};
